function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#4d4d4d",
  d: "M19.13 0v3.19h-4.78v-1.6H7.97v1.6H3.19V0H0v7.97h3.19V4.78h4.78v1.6h6.38v-1.6h4.78v3.19h3.18V0h-3.18zM19.13 23.91h-4.78v-1.59H7.97v1.59H3.19v-3.19H0v7.97h3.19V25.5h4.78v1.6h6.38v-1.6h4.78v3.19h3.18v-7.97h-3.18v3.19z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#b3b3b3",
  d: "M14.35 11.16h-2.4V6.38h-1.59v4.78H7.97v6.37h2.39v4.79h1.59v-4.79h2.4v-6.37z"
});

var SvgSingle4Wd = function SvgSingle4Wd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 22.31 28.69"
  }, props), _ref, _ref2);
};

export default SvgSingle4Wd;